export default __webpack_public_path__ + "static/media/运动场_white.ae8f03da.jpg";